// extracted by mini-css-extract-plugin
module.exports = {"background":"App_ketogo_background__uZEoq"};